import request from "../common/requests/request";
import config from "../common/config/main.config";
import serviceResultFactory from "../common/requests/serviceResultFactory";
import { NUMBER_OF_SESSIONS_IN_ONE_CALL } from "../common/constants";

const getEventEditionById = (eventEditionId: string) => {
  const baseApiUrl = config.getConfig(process.env.REACT_APP_ENVIRONMENT).baseApiUrl;
  const returnFields = `
    name
    id
    gbsCode
    startDate
    endDate
    defaultCurrencyCode
    eventGbsCode
    domain
    defaultCurrencyCode
    isECommerceEnabled
    isAbnRequired
    isAnonymousRegistrationEnabled
    isPhotoRequiredForAccess
    isOnsiteIdCheckEnabled
    businessUnitGbsCode
    colocatedShows {
      eventEditionId
    }
    multiEventInfo {
      primaryEventEditionId
      secondaryEventEditionIds
    }
    primaryLocale
    supportedLocales
    isParticipationEvent
    openingHours {
      localEndTime
      localStartTime
    }
    `;

  const query = `{
      eventEdition(eventEditionId: "${eventEditionId}")
      {
        ${returnFields}
      } 
    }`;

  return request
    .graphqlRequest(`${baseApiUrl}/graphql`, query)
    .then(serviceResultFactory.fromGraphqlResponse)
    .catch(serviceResultFactory.fromGraphqlError);
};

const getEventEditionBadges = (eventEditionGbsCode: string, modifiedDate?: string) => {
  const baseApiUrl = config.getConfig(process.env.REACT_APP_ENVIRONMENT).baseApiUrl;

  let modifiedDateField = "";

  if (modifiedDate) {
    modifiedDateField = `, modifiedDate: "${modifiedDate}"`;
  }

  const query = `
    query { 
      badges
      ( 
          eventEditionGbsCode: "${eventEditionGbsCode}"
          ${modifiedDateField}
      ){
          id
          registrationId
          productCode
          customerType
          status
          badgeLocation
          qrCodeContent
          marketingPreferencesPromptRequired
          organisation{
              displayName
              countryCode
              state
              standIds
              countryCode
              state
          }
          contact{
              firstName
              lastName
              jobTitle
              email
          }
      }
    }
    `;
  return request
    .graphqlRequestWithBearer(`${baseApiUrl}/graphql`, query)
    .then(serviceResultFactory.fromGraphqlResponse)
    .catch(serviceResultFactory.fromGraphqlError);
};

const getSessionsByEvent = (eventEditionId: string, offset: number) => {
  const baseApiUrl = config.getConfig(process.env.REACT_APP_ENVIRONMENT).baseApiUrl;
  const query = `
    query {
      sessions(
      eventEditionId: "${eventEditionId}"
      offset: ${offset}
      first: ${NUMBER_OF_SESSIONS_IN_ONE_CALL}) {
        id
        title
        location
      }
    }
  `;

  return request
    .graphqlRequest(`${baseApiUrl}/graphql`, query)
    .then(serviceResultFactory.fromGraphqlResponse)
    .catch(serviceResultFactory.fromGraphqlError);
};

const getExhibitingOrganisations = (eventEditionId: string, first?: number, offset?: number) => {
  const baseApiUrl = config.getConfig(process.env.REACT_APP_ENVIRONMENT).baseApiUrl;
  const nextMultilingualItems = Number.isInteger(first) && Number.isInteger(offset) ? `, first: ${first}, offset: ${offset}` : '';
  const query = `{
    exhibitingOrganisationsPublicList(eventEditionId: "${eventEditionId}"${nextMultilingualItems}) {
      exhibitingOrganisations {
        id
        organisationId
        exhibitorType
        multilingual {
         displayName
         locale
         addressLine1
         city
         postcode
         countryCode
         stateProvince
         logoUrl
        }
        stands {
          name
        }
       }
     }
  }`;
  return request
    .graphqlRequest(`${baseApiUrl}/graphql`, query)
    .then(serviceResultFactory.fromGraphqlResponse)
    .catch(serviceResultFactory.fromGraphqlError);
};

const updateBadge = (id: string, jobTitle: string, firstName: string, lastName: string, customerType = "", productCode = "") => {
  const baseApiUrl = config.getConfig(process.env.REACT_APP_ENVIRONMENT).baseApiUrl;
  const customerTypeField = customerType ? `customerType: "${customerType}"` : "";
  const productCodeField = productCode ? `productCode: "${productCode}"` : "";
  const query = `
  mutation { 
    updateBadge
    ( 
        id: "${id}",
        contact :
        {
          firstName: "${firstName}"
          lastName: "${lastName}"
          jobTitle: "${jobTitle}"
        }
        ${customerTypeField}
        ${productCodeField}
    )}
    `;
  return request
    .graphqlRequestWithBearer(`${baseApiUrl}/graphql`, query)
    .then(serviceResultFactory.fromGraphqlResponse)
    .catch(serviceResultFactory.fromGraphqlError);
};

const RingboxService = {
  getEventEditionById,
  getEventEditionBadges,
  getSessionsByEvent,
  updateBadge,
  getExhibitingOrganisations
};

export default RingboxService;
